export const createMapConfig = (container, isSingleCountry, lng, lat, zoom) => {
    const config = {
        container,
        style: 'mapbox://styles/mapbox/light-v11',
        projection: 'mercator',
        zoom,
        cooperativeGestures: true,
        performanceMetricsCollection: false,
    };

    if (!isSingleCountry) {
        config.center = [lng, lat];
    }

    return config;
};
